import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'employee_guid': 'String!',
	'active': 'String',
};

export default gql(`
	mutation user_employee( ${ HelperGraphql.createFields( fields ) } ) {
	    user_employee( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
			active
	    }
	}
`);

